import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { I18nModule } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { CartExportComponent } from './cart-export.component';

@NgModule({
  exports: [CartExportComponent],
  imports: [CommonModule, MatIconModule, IconModule, I18nModule, CartExportComponent],
})
export class CartExportModule {}
